import { useLanguage } from "@/context/LanguageContext";
import { COMPANY } from "@/data/content";
import { scrollToId } from "@/utils/scroll";

export default function Logo() {
    const { L } = useLanguage();
    return (
        <button
            onClick={() => scrollToId("home")}
            data-testid="logo-home"
            className="group flex items-center gap-3"
            aria-label="Home"
        >
            <img
                src="/logo.jpg"
                alt="X New Line"
                className="size-11 shrink-0 rounded-lg object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <span className="text-start leading-none">
                <span className="font-display block text-lg font-bold text-brass-bright">
                    {L(COMPANY.name)}
                </span>
                <span className="font-mono-x mt-1 block text-[9px] tracking-[0.32em] text-txt-3">
                    GUANGZHOU · CHINA
                </span>
            </span>
        </button>
    );
}
